"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterWrapper = exports.tableLoaderStyle = void 0;
const styles_1 = require("@mui/material/styles");
exports.tableLoaderStyle = { height: "250px", marginBottom: "120px" };
exports.FilterWrapper = (0, styles_1.styled)("div")({
    display: "flex",
    maxWidth: "30%",
    marginBottom: "24px",
});
